import { useCallback } from 'react';
import { Text } from 'slate';
import { escapeRegExp } from 'lodash';

import { getWordBoundaryRegExp } from 'src/lib/string';
import { HIGHLIGHT_MARK } from 'src/data/markedText';

const matchingIndexes = (text, word) => {
  const escapedKeyword = escapeRegExp(word);
  return [...text.matchAll(getWordBoundaryRegExp(escapedKeyword.toLowerCase()))].map((a) =>
    a.index !== 0 ? a.index + 1 : a.index
  );
};

export const useDecorateBlogSection = (highlightedWords, decoratedWords) => {
  return useCallback(
    ([node, path]) => {
      if (!Text.isText(node)) {
        return [];
      }

      const ranges = [];
      highlightedWords.forEach((word) => {
        const indexes = matchingIndexes(node.text, word);

        const newRanges = indexes.map((index) => {
          const endIndex = index + word.length;
          return {
            anchor: { path, offset: index },
            focus: { path, offset: endIndex },
            highlight: true,
          };
        });
        ranges.push(...newRanges);
      });

      decoratedWords.forEach((word) => {
        const indexes = matchingIndexes(node.text, word);

        const newRanges = indexes.map((index) => {
          const endIndex = index + word.length;
          return {
            anchor: { path, offset: index },
            focus: { path, offset: endIndex },
            decoration: word.decoration || HIGHLIGHT_MARK.warning,
          };
        });
        ranges.push(...newRanges);
      });

      return ranges;
    },
    [decoratedWords, highlightedWords]
  );
};
